import React from "react";
import ContactInfoCard from "./ContactInfoCard";
import DemoFormCard from "./DemoFormCard";

const ContactSection = () => {
  return (
    <section className="py-24 px-3 sm:px-4 lg:px-6 bg-[#fdfdfd]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 px-4">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] mb-6 tracking-tight leading-tight">
            Let's Boost Your{" "}
            <span className="text-[#0066ff]">Dental Case Acceptance</span> 
            <br />
            with AI Simulation
          </h2>
          <p className="text-slate-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Tell us about your dental practice — whether you're a solo clinic,
            cosmetic dentistry office, or multi-location DSO — and we'll show
            you exactly how SmileReveal™ AI smile simulation can improve your
            case acceptance rate, generate more implant leads, and grow revenue.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Left: Contact Info */}
          <div className="lg:col-span-4 h-full">
            <ContactInfoCard />
          </div>

          {/* Right: Demo Form */}
          <div className="lg:col-span-8 h-full">
            <DemoFormCard />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
